/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import './device';
import './application_type';
import '../../connect/v2/common/date';
import './event_type';
import '../../connect/v2/common/sort';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "connect": {
        "nested": {
          "v2": {
            "nested": {
              "SearchDevicesQuery": {
                "fields": {
                  "filter": {
                    "type": ".squareup.connect.v2.SearchDevicesFilter",
                    "id": 1,
                    "rule": "optional"
                  },
                  "sort": {
                    "type": ".squareup.connect.v2.SearchDevicesSort",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "SearchDevicesFilter": {
                "fields": {
                  "deviceTypes": {
                    "type": ".squareup.connect.v2.DeviceAttributes.DeviceType",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "locationIds": {
                    "type": "string",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "applicationTypes": {
                    "type": ".squareup.connect.v2.ApplicationType",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "deviceName": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "batteryLevel": {
                    "type": ".squareup.connect.v2.IntRange",
                    "id": 5,
                    "rule": "optional"
                  },
                  "updatedAt": {
                    "type": ".squareup.connect.v2.common.TimeRange",
                    "id": 6,
                    "rule": "optional"
                  },
                  "lastUsedAt": {
                    "type": ".squareup.connect.v2.common.TimeRange",
                    "id": 7,
                    "rule": "optional"
                  },
                  "deviceProfileId": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "statusCategories": {
                    "type": ".squareup.connect.v2.DeviceStatus.Category",
                    "id": 9,
                    "rule": "repeated"
                  },
                  "keyword": {
                    "type": "string",
                    "id": 10,
                    "rule": "optional"
                  },
                  "squareHardwareTypes": {
                    "type": ".squareup.connect.v2.DeviceAttributes.SquareHardwareType",
                    "id": 11,
                    "rule": "repeated"
                  },
                  "deviceEventTypes": {
                    "type": ".squareup.connect.v2.DeviceEventType",
                    "id": 12,
                    "rule": "repeated"
                  },
                  "modeId": {
                    "type": "string",
                    "id": 13,
                    "rule": "optional"
                  }
                }
              },
              "IntRange": {
                "fields": {
                  "start": {
                    "type": "int32",
                    "id": 1,
                    "rule": "optional",
                    "options": {
                      "default": 0
                    }
                  },
                  "end": {
                    "type": "int32",
                    "id": 2,
                    "rule": "optional",
                    "options": {
                      "default": 100
                    }
                  }
                }
              },
              "SearchDevicesSort": {
                "fields": {
                  "sortField": {
                    "type": ".squareup.connect.v2.SearchDevicesSort.SearchDevicesSortField",
                    "id": 1,
                    "rule": "optional"
                  },
                  "sortOrder": {
                    "type": ".squareup.connect.v2.common.SortOrder",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "SearchDevicesSortField": {
                    "values": {
                      "NAME": 0,
                      "BATTERY_LEVEL": 1,
                      "LAST_UPDATED": 2,
                      "STATUS": 3,
                      "LOCATION_NAME": 4,
                      "DEVICE_ID": 5,
                      "DEVICE_CODE_NAME": 6
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.SearchDevicesQuery && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.SearchDevicesFilter && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.IntRange && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.SearchDevicesSort && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.SearchDevicesSort?.nested?.SearchDevicesSortField) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE SearchDevicesQuery @ squareup/devices/external/search_devices_query.proto at 18:1
 */
export const SearchDevicesQuery = $root.lookupType('squareup.connect.v2.SearchDevicesQuery');
fixType(SearchDevicesQuery);
Builder.createAndAttachToType(SearchDevicesQuery);
/**
 * SOURCE SearchDevicesFilter @ squareup/devices/external/search_devices_query.proto at 26:1
 */
export const SearchDevicesFilter = $root.lookupType('squareup.connect.v2.SearchDevicesFilter');
fixType(SearchDevicesFilter);
Builder.createAndAttachToType(SearchDevicesFilter);
/**
 * SOURCE IntRange @ squareup/devices/external/search_devices_query.proto at 61:1
 */
export const IntRange = $root.lookupType('squareup.connect.v2.IntRange');
fixType(IntRange);
Builder.createAndAttachToType(IntRange);
/**
 * SOURCE SearchDevicesSort @ squareup/devices/external/search_devices_query.proto at 71:1
 */
export const SearchDevicesSort = $root.lookupType('squareup.connect.v2.SearchDevicesSort');
fixType(SearchDevicesSort);
Builder.createAndAttachToType(SearchDevicesSort);
/**
 * SOURCE SearchDevicesSortField @ squareup/devices/external/search_devices_query.proto at 74:3
 */
SearchDevicesSort.SearchDevicesSortField = $root.lookupEnum('squareup.connect.v2.SearchDevicesSort.SearchDevicesSortField').values;